import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Jeff Anders
 * id 43E0329D-4E25-4E9B-AFCD-22EC47EEC2C5
 * name upload-circle
 * version: 7.4.47
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/upload-circle.svg
 * tags
 */
export const UploadCircleIcon = createSvgIcon(<><path d="M12 2C17.5 2 22 6.5 22 12C22 17.5 17.5 22 12 22C6.5 22 2 17.5 2 12C2 6.5 6.5 2 12 2ZM16 17V15H8V17H16ZM16 10L12 6L8 10H10.5V14H13.5V10H16Z" /></>, 'UploadCircleIcon');
export default UploadCircleIcon